import { createUseStyles, Styles } from 'react-jss';

export default createUseStyles((theme: Styles) => ({
  multiselect: {
    height: '100%',
    backgroundColor: theme.white1
  }
}));
